import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader } from "@/components/admin/ui";

export default function Audit() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/admin/audit").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="admin-audit">
      <PageHeader title="Audit Log" subtitle="Record of important administrative actions" />
      <div className="bg-white rounded-2xl border border-stone-200/80 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-stone-50 text-stone-500 text-left"><tr><th className="px-5 py-3 font-medium">When</th><th className="px-5 py-3 font-medium">User</th><th className="px-5 py-3 font-medium">Action</th><th className="px-5 py-3 font-medium">Entity</th></tr></thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={4} className="text-center text-stone-400 py-10">No events yet.</td></tr>}
            {items.map((a) => (
              <tr key={a.id} className="border-t border-stone-100">
                <td className="px-5 py-3 font-mono text-xs text-stone-500">{(a.created_at || "").slice(0, 19).replace("T", " ")}</td>
                <td className="px-5 py-3 text-stone-700">{a.user_email}</td>
                <td className="px-5 py-3"><span className="text-xs font-semibold bg-emerald-50 text-emerald-700 px-2 py-0.5 rounded capitalize">{a.action}</span></td>
                <td className="px-5 py-3 text-stone-600">{a.entity} <span className="font-mono text-xs text-stone-400">{a.entity_id}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
